import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  [types.RESET_PUBLISHED](state) {
    state.appliedUpdates = {};
    state.appliedUpdateIds = [];
    state.complispacePublished = {};
    state.complispacePublishedIds = [];
  },

  [types.BULK_ADD_APPLIED_UPDATES](state, updates) {
    state.appliedUpdateIds = [];
    state.appliedUpdates = updates.reduce((result, updateItem) => {
      result[updateItem.publishId] = updateItem;
      state.appliedUpdateIds.push(updateItem.publishId);
      return result;
    }, {});
  },

  [types.BULK_ADD_COMPLISPACE_PUBLISHED](state, published) {
    state.complispacePublishedIds = [];
    state.complispacePublished = published.reduce((result, publishItem) => {
      result[publishItem.id] = publishItem;
      state.complispacePublishedIds.push(publishItem.id);

      return result;
    }, {});
  },

  [types.SET_PUBLISH_AT](state, { publishAt, id }) {
    state.appliedUpdates[id].publishAt = publishAt;
  }
  /* eslint-enable no-param-reassign */
};
